import React from "react";
import "../styles/nightlifeLanding.css";
import LandingShell from "./LandingShell";

export default function AccessLandingScreen() {
  // ✅ ADD THIS
  const scenarios = {
    Workers: {
      src: "/assets/worker.mp4",
      poster: "/images/worker-poster.jpg",
      caption: "Workers: reliable access while on the job — no awkward asks.",
    },
    Tourists: {
      src: "/assets/tourist.mp4",
      poster: "/images/tourist-poster.jpg",
      caption: "Tourists: trusted access in a new city — confidence and relief.",
    },
    Families: {
      src: "/assets/family.mp4",
      poster: "/images/family-poster.jpg",
      caption: "Families: quick, trusted access when kids need a bathroom now.",
    },
  };

  return (
    <LandingShell
      theme="dark" // we can switch to light later
      brandTag="Access Anywhere"
      headlineTop="Reliable"
      headlineAccent="Bathroom Access"
      subheadline={
        <>
          Pay2Pee helps people find clean, trusted bathrooms—whether you’re out for the night,
          working on the move, or exploring a new city.
        </>
      }

      // ✅ ADD THIS LINE
      scenarios={scenarios}
      scenarioLabel="Real-world scenarios"

      pills={["Families", "Workers", "Tourists"]}
      stripItems={[
        { kicker: "Fast", value: "Find access quickly" },
        { kicker: "Trusted", value: "Cleaner partner bathrooms" },
        { kicker: "Fair", value: "Clear rules + pricing" },
      ]}
      howSteps={[
        { icon: "📍", title: "Find nearby access", text: "See participating locations around you." },
        { icon: "💳", title: "Pay digitally", text: "No awkward asks—clear access rules." },
        { icon: "✅", title: "Use and go", text: "Reliable access when you need it." },
      ]}
      benefits={[
        {
          title: "Increase Foot Traffic",
          text: "Turn nearby demand into new visits. Pay2Pee brings people to your location who may not have otherwise walked in.",
        },
        {
          title: "Capture Event Demand",
          text: "Sporting events, festivals, conventions, and peak weekends create sudden demand. Pay2Pee helps you benefit without chaos.",
        },
        {
          title: "Earn Passive Income",
          text: "Monetize restroom access during high-demand windows with minimal staff involvement and no upfront cost.",
        },
        {
          title: "You Set the Rules",
          text: "Choose when you participate, set pricing, limit access, or pause anytime. Pay2Pee works on your terms.",
        },
      ]}
      ctaTitle="Get Pay2Pee for your business"
      ctaText="Drop your info and we’ll share next steps."
      ctaBullets={["Fast onboarding", "Set your rules", "Digital payments"]}
      primaryCtaText="Get Partner Info"
      faq={[
        { q: "Is this only for nightlife?", a: "No. Pay2Pee supports multiple real-world use cases—from nightlife to workers and tourists." },
        { q: "Do partners control access?", a: "Yes. Partners set availability, pricing, and rules." },
      ]}
    />
  );
}